'use stric'

const mapState = {
  baseSize: {
    name: 'baseSize'
  },
  fullSize: {
    name: 'fullSize'
  }
}

export {
  mapState
}